import "../css/blockcolumn.css";
import { motion } from "framer-motion";
import line1 from "../img/line1.png";
import line2 from "../img/line2.png";
function Block3Columns(props) {
  return (
    <div className="wrpper-blockcolumn-relative">
      <div className="block-columntitle block-column">
        <div className=" layout8">
          <div className="col3">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.1,
                },
              }}
            >
              <div className="layout9">{props.col1}</div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.2,
                },
              }}
            >
              <div className="layout9">{props.col2}</div>
            </motion.div>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                delay: 0.3,
              }}
            >
              <div className="layout9">{props.col3}</div>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="bg-line1">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line1" src={line1} alt="utpl"></img>
        </motion.div>
      </div>

      <div className="bg-line2">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line2" src={line2} alt="utpl"></img>
        </motion.div>
      </div>

      <div className="bg-line3">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line3" src={line2} alt="utpl"></img>
        </motion.div>
      </div>
    </div>
  );
}

export default Block3Columns;
